import { useState, useCallback } from 'react';

export const useOohState = () => {
  const [selectedCourier, setSelectedCourier] = useState<number | null>(null);
  const [expandedTrips, setExpandedTrips] = useState<Set<number>>(new Set());

  const handleCourierCardClick = useCallback((courierId: number) => {
    setSelectedCourier((prev) => (prev === courierId ? null : courierId));
  }, []);

  const toggleTripExpansion = useCallback((tripId: number) => {
    setExpandedTrips((prev) => {
      const newExpanded = new Set(prev);
      if (newExpanded.has(tripId)) {
        newExpanded.delete(tripId);
      } else {
        newExpanded.add(tripId);
      }
      return newExpanded;
    });
  }, []);

  const resetSelectedCourier = useCallback(() => {
    setSelectedCourier(null);
  }, []);

  return {
    selectedCourier,
    expandedTrips,
    handleCourierCardClick,
    toggleTripExpansion,
    resetSelectedCourier,
  };
};